export enum UploadStages {
  awaitingFile,
  filePicked,
  fetchedFileDetails,
  updatedFile,
  createdMoment,
  downgradePermission
};
